"use client";

import { Container } from "@/components/ui/container";
import SupportBlock from "@/components/entities/support-block";
import ServiceSearchHeader from "@/views/service-center/search/components/service-search-header";
import ServiceSearchMain from "@/views/service-center/search/components/service-search-main";
import { useServiceCenterSearchData } from "@/views/service-center/search/hooks/useServiceCenterSearchData";
import S from "../index.module.scss";

const ServiceCenterSearchView = () => {
  const {
    serviceCenterPage: { serviceCenterPage, loading: serviceCenterPageLoading },
  } = useServiceCenterSearchData();

  if (!serviceCenterPage || serviceCenterPageLoading) return <></>;

  return (
    <>
      <ServiceSearchHeader video={serviceCenterPage.page.video} />
      <Container className={S.mainWrapper}>
        <ServiceSearchMain />
        <SupportBlock info={serviceCenterPage.block} />
      </Container>
    </>
  );
};

export default ServiceCenterSearchView;
